<script>
  import {tick, onMount, createEventDispatcher} from 'svelte'

  import Section1 from './digital/DigitalSection1.svelte'
  import Section2 from './digital/DigitalSection2.svelte'
  import Section3 from './linear/LinearSection5.svelte'
  import Section4 from './digital/DigitalSection4.svelte'
  import Section5 from './digital/DigitalSection5.svelte'
  import Section6 from './digital/DigitalSection6.svelte'
  import Section7 from './digital/DigitalSection7.svelte'
  import Section8 from './digital/DigitalSection8.svelte'
  import EndSection from './EndSection.svelte'

  const dispatch = createEventDispatcher()

  onMount(async () => {
    await tick()
    dispatch('mounted', {path: 'linear'})
  })
</script>

<Section1 />
<Section2 />
<Section3
  title="Access trusted supply through Verizon Media DSP."
  subtitle="Run CTV ads on major networks and publishers, including live TV, and get first-in-market self-serve access to HH Addressable TV across DISH and Fios."
  hasDSP={true}
  />
<Section4 />
<Section5 />
<Section6 />
<Section7 />
<Section8 />
<EndSection on:path />